export default "__VITE_ASSET__CP_ngYFl__"